/** Copyright fijo Vault (no usa LAYOUT.FOOTER_COPYRIGHT del ERP). */
export const VAULT_FOOTER_COPYRIGHT =
  '© Nebula Vault. Elaborado por Centrica Soluciones Innovadoras.';

export const VAULT_FOOTER_I18N_FALLBACKS: Record<string, string> = {
  'LAYOUT.CONN_OK': 'Conexión establecida',
  'LAYOUT.CONN_FAIL': 'Conexión no establecida',
};
